import React from "react";

import "./Footer.scss";

import firstlineNNPHILogo from "../../assets/img/NNPHI-PFL_Logo-Lockup.png";
import pdfIcon from "../../assets/img/file-pdf-solid.svg";
// import myPdf from "../../assets/pdf/NNPHI_Scrolly3_Infograhic-Why-Does-Contact-Time-Matter-508.pdf";
//import firstlineNNPHILogo from "../../assets/img/PFL-NNPHI_logo-Lockup.png";

export default function Footer() {
  const handleClick = () => {
    window.scrollTo(0, 0);
    window.location.reload();
  };

  return (
    <>
      <nav className="repeat-button" onClick={handleClick}>
        <span className="loop">&#8635;</span> Repeat Experience
      </nav>
      <footer className="footer">
        <div className="footer__text">
          For more information on topics like this, visit
        </div>
        <a
          href="https://www.cdc.gov/projectfirstline"
          rel="noopener nofollow noreferrer"
          target="_blank"
          className="footer__firstline-link"
        >
          cdc.gov/projectfirstline
        </a>
        <div className="footer__logo">
          <img src={firstlineNNPHILogo} alt="" className="img-fluid" />
        </div>
        <a
          href="https://ipc.nnphi.org/wp-content/uploads/2023/07/NNPHI_Scrolly3_Infograhic-Why-Does-Contact-Time-Matter-508.pdf"
          className="footer__pdfLink"
          target="_blank"
          rel="noreferrer"
        >
          <span>
            <img src={pdfIcon} alt="" className="img-fluid" />
          </span>
          Accessible PDF Version
        </a>
        <button className="footer__repeat-button" onClick={handleClick}>
          <span className="loop">&#8635;</span> Repeat Experience
        </button>
        <a
          href="http://ipc.nnphi.org/learn/"
          rel="noopener nofollow noreferrer"
          target="_blank"
          className="footer__scrolly-link"
        >
          See all of NNPHI’s Project Firstline interactive learning experiences.
        </a>
      </footer>
    </>
  );
}
